import React, { useEffect } from "react";
import { Button, Form, Input, Select, DatePicker } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { getHomeCity } from "../../../Redux/actions/getHomeCity";
import { getHomeOccupation } from "../../../Redux/actions/getHomeOccupation";

const HomeFormFour = ({ onFinishStep4, onFinishFailedFour,handlePrev,form }) => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const formthreeData = useSelector((state) => state.postHomeFormThree.data);
  const homeCityData = useSelector((state) => state.getHomeCity.data);
  const homeOccupationData = useSelector(
    (state) => state.getHomeOccupation.data
  );

  const genderData = [
    {
      value: "M",
      title: "Male",
    },
    {
      value: "F",
      title: "Female",
    },
  ];
  useEffect(() => {
    dispatch(getHomeCity());
    dispatch(getHomeOccupation());
  }, [dispatch]);
  return (
    <div className="col-sm-8 mForm" style={{ backgroundColor: "rgb(30 123 95 / 69%)" }} >
      <div className="centreWidthFOrm">
        <h3 className="cnhbsh3">Salaam Home Takaful</h3>
        <h5 className="cnhbsh5"> Plan Name: {formthreeData?.Coverage}</h5>
        <Form
          name="sehatFormTwo"
          onFinish={onFinishStep4}
          onFinishFailed={onFinishFailedFour}
          autoComplete="off"
          layout="vertical"
          form={form}
        >
          <div className="row">
            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="CNIC"
                label="CNIC Number"
                rules={[
                  {
                    required: true,
                    pattern: /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/,
                    message:
                      "Please enter a valid CNIC number in the format XXXXX-XXXXXXX-X",
                  },
                ]}
                normalize={(value) => {
                  if (!value) {
                    return value;
                  }

                  const onlyNums = value.replace(/[^\d]/g, "");
                  if (onlyNums.length <= 5) {
                    return onlyNums.slice(0, 5);
                  }
                  if (onlyNums.length <= 12) {
                    return `${onlyNums.slice(0, 5)}-${onlyNums.slice(5, 12)}`;
                  }
                  return `${onlyNums.slice(0, 5)}-${onlyNums.slice(
                    5,
                    12
                  )}-${onlyNums.slice(12, 13)}`;
                }}
              >
                <Input placeholder="CNIC #" />
              </Form.Item>
            </div>

            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="CNICEXP"
                label="CNIC Expiry Date"
                rules={[
                  {
                    required: true,
                    message: "CNIC Expiry Date is required!",
                  },
                ]}
              >
                <DatePicker placeholder="CNIC Expiry" />
              </Form.Item>
            </div>

            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="Gender"
                label="Gender"
                rules={[
                  {
                    required: true,
                    message: "Please select Gender!",
                  },
                ]}
              >
                <Select placeholder="Gender">
                  {genderData.map((item, i) => (
                    <Select.Option value={item.value}>
                      {item.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="Occupation"
                label="Occupation"
                rules={[
                  {
                    required: true,
                    message: "Please select occupation!",
                  },
                ]}
              >
                <Select
                  placeholder="Occupation"
                  showSearch
                  filterOption={(inputValue, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(inputValue.toLowerCase()) >= 0
                  }
                >
                  {homeOccupationData?.map((item, i) => (
                    <Option key={i} value={item?.Occupation_code}>
                      {item?.Occupation_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="DOB"
                label="Date Of Birth"
                rules={[
                  {
                    required: true,
                    message: "DOB is requied!",
                  },
                ]}
              >
                <DatePicker
                  placeholder="Date Of Birth"
                  disabledDate={(current) => current && current > new Date()}
                />
              </Form.Item>
            </div>
            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="Email"
                label="Email"
                rules={[
                  {
                    type: "email",
                    message: "Email is not valid",
                  },
                  {
                    message: "Email is required!",
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>
            </div>
            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="Contact"
                label="Contact"
                rules={[
                  {
                    required: true,
                    pattern: /^03\d{2}-\d{7}$/,
                    message:
                      "Contact number must be in this format 03XX-XXXXXXX",
                  },
                ]}
                normalize={(value) => {
                  if (!value) {
                    return value;
                  }
                  const onlyNums = value.replace(/[^\d]/g, "");
                  if (onlyNums.length <= 4) {
                    return onlyNums;
                  } else if (onlyNums.length <= 11) {
                    return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4, 11)}`;
                  }
                  return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4, 11)}`;
                }}
              >
                <Input placeholder="Contact 03XX-XXXXXXX" />
              </Form.Item>
            </div>
            <div className="col-sm-6 labelSSS">
              <Form.Item
                name="CITY"
                label="City"
                rules={[
                  {
                    required: true,
                    message: "Please Select City!",
                  },
                ]}
              >
                <Select
                  placeholder="City"
                  showSearch
                  filterOption={(inputValue, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(inputValue.toLowerCase()) >= 0
                  }
                >
                  {homeCityData?.map((item, i) => (
                    <Option key={i} value={item?.city_code}>
                      {item?.city_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="col-sm-12 labelSSS">
              <Form.Item
                name="Address"
                label="Address"
                rules={[
                  {
                    required: true,
                    message: "Address is required!",
                  },
                ]}
              >
                <Input placeholder="Address" />
              </Form.Item>
            </div>
            <div className="col-sm-6">
              <Button onClick={handlePrev}>Back</Button>
            </div>
            <div className="col-sm-6">
              <Button
                type="primary"
                htmlType="submit"
                style={{ background: "#1C75BC" }}
              >
                Next
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default HomeFormFour;